/* ==========================================================================
 * NOTE: These types are brought over from jslib/types/runtimetypes.
 *       Other types should be brought over when they need to be shared.
 * ========================================================================== */

export enum VerificationStepsEnum {
  collectStudentPersonalInfo = "collectStudentPersonalInfo",
  collectTeacherPersonalInfo = "collectTeacherPersonalInfo",
  collectMemberPersonalInfo = "collectMemberPersonalInfo",
  collectMilitaryStatus = "collectMilitaryStatus",
  collectActiveMilitaryPersonalInfo = "collectActiveMilitaryPersonalInfo",
  collectInactiveMilitaryPersonalInfo = "collectInactiveMilitaryPersonalInfo",
  collectSeniorPersonalInfo = "collectSeniorPersonalInfo",
  collectAgePersonalInfo = "collectAgePersonalInfo",
  collectFirstResponderPersonalInfo = "collectFirstResponderPersonalInfo",
  collectMedicalProfessionalPersonalInfo = "collectMedicalProfessionalPersonalInfo",
  collectEmployeePersonalInfo = "collectEmployeePersonalInfo",
  collectSocialSecurityNumber = "collectSocialSecurityNumber",
  cancelSocialSecurityNumber = "cancelSocialSecurityNumber",
  collectDriverLicensePersonalInfo = "collectDriverLicensePersonalInfo",
  collectGeneralIdentityPersonalInfo = "collectGeneralIdentityPersonalInfo",
  collectHybridIdentityPersonalInfo = "collectHybridIdentityPersonalInfo",
  collectLicensedProfessionalPersonalInfo = "collectLicensedProfessionalPersonalInfo",
  collectMoverPersonalInfo = "collectMoverPersonalInfo",
  collectLowIncomePersonalInfo = "collectLowIncomePersonalInfo",
  collectIdentifier = "collectIdentifier",
  collectPersonalInfo = "collectPersonalInfo",
  docUpload = "docUpload",
  pending = "pending",
  docReviewLimitExceeded = "docReviewLimitExceeded",
  success = "success",
  error = "error",
  sso = "sso",
  smsLoop = "smsLoop",
  emailLoop = "emailLoop",
  emailLoopCollectOrganizationEmail = "emailLoopCollectOrganizationEmail",
  completeAuthentication = "completeAuthentication",
  cancelEmailLoop = "cancelEmailLoop",
  idCheckLoop = "idCheckLoop",
  consolation = "consolation",
  override = "override",
  cancelDocUpload = "cancelDocUpload",
  missingRequiredMetadata = "missingRequiredMetadata",
  missingRequiredExternalId = "missingRequiredExternalId",
  thirdPartyLoop = "thirdPartyLoop",
}
export const VerificationSteps = Object.values(VerificationStepsEnum) as any; // For runtime checks

export const CollectInfoSteps = [
  VerificationStepsEnum.collectStudentPersonalInfo,
  VerificationStepsEnum.collectTeacherPersonalInfo,
  VerificationStepsEnum.collectMemberPersonalInfo,
  VerificationStepsEnum.collectMilitaryStatus,
  VerificationStepsEnum.collectActiveMilitaryPersonalInfo,
  VerificationStepsEnum.collectInactiveMilitaryPersonalInfo,
  VerificationStepsEnum.collectSeniorPersonalInfo,
  VerificationStepsEnum.collectAgePersonalInfo,
  VerificationStepsEnum.collectFirstResponderPersonalInfo,
  VerificationStepsEnum.collectMedicalProfessionalPersonalInfo,
  VerificationStepsEnum.collectEmployeePersonalInfo,
  VerificationStepsEnum.collectDriverLicensePersonalInfo,
  VerificationStepsEnum.collectGeneralIdentityPersonalInfo,
  VerificationStepsEnum.collectHybridIdentityPersonalInfo,
  VerificationStepsEnum.collectLicensedProfessionalPersonalInfo,
  VerificationStepsEnum.collectMoverPersonalInfo,
  VerificationStepsEnum.collectLowIncomePersonalInfo,
  VerificationStepsEnum.collectIdentifier,
  VerificationStepsEnum.collectPersonalInfo,
] as const;
// eslint-disable-next-line no-redeclare -- this works fine if it's a type and a value
export type CollectInfoSteps = (typeof CollectInfoSteps)[number];

export enum MockStepsEnum {
  loading = "loading",
  collect = "collect",
}
const unMockableSteps: VerificationStepsEnum[] = [
  VerificationStepsEnum.cancelDocUpload,
  VerificationStepsEnum.cancelEmailLoop,
  VerificationStepsEnum.cancelSocialSecurityNumber,
  VerificationStepsEnum.collectMilitaryStatus, // currently not a useful step to mock
];

export const MockSteps = [
  ...(Object.values(VerificationStepsEnum).filter(
    (step) => !unMockableSteps.includes(step),
  ) as any),
  ...(Object.values(MockStepsEnum) as any),
];

export function isCollectStep(step: unknown): step is CollectInfoSteps {
  return CollectInfoSteps.includes(step as CollectInfoSteps);
}

export interface NavigatorBeta extends Navigator {
  globalPrivacyControl: boolean;
}
